import React from 'react'
import useCmsDetails from '../hooks/useCmsDetails'
import CreateCms from './CreateCms'
import Preloader from '../../../../components/Preloader'

const EditCms = () => {
  const { cmsByPageIdData, loading } = useCmsDetails()


  return (
    <CreateCms cmsData={cmsByPageIdData} loading={loading} />
  )
}

export default EditCms
